import {
    IDadosOportunidade,
    IInserirNovaOportunidadeLeadResponse,
} from "../../../Interfaces/Vendas/Oportunidade/OportunidadeInterface";
import AxiosVendas from "../../Config/ApiVendas";
import Service from "../../Service";

export async function InserirNovaOportunidadeLeadService(ID_LEAD: number) {
    return Service(
        AxiosVendas.post<Array<IInserirNovaOportunidadeLeadResponse>>(
            `/app/oportunidade/inserirnovaoportunidadelead?ID_LEAD=${ID_LEAD}`
        )
    );
}

export async function EditarOportunidadeLeadService(
    requestBody: IDadosOportunidade
) {
    return Service(
        AxiosVendas.put(`/app/oportunidade/editaroportunidade`, requestBody)
    );
}
export async function DadosOportunidadeLeadService(ID_OPORTUNIDADE: number) {
    return Service(
        AxiosVendas.get<IDadosOportunidade>(
            `/app/oportunidade/dadosoportunidade?ID_OPORTUNIDADE=${ID_OPORTUNIDADE}`
        )
    );
}
